"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractFragments = exports.contractFragment = void 0;
const document_1 = require("./document");
exports.contractFragment = `
  fragment contract on Contract {
    calculations {
      ...calculation
    }
    documents {
      ...document
    }
    id
    order {
      id
    }    
    tradeInVehicles {
      ...vehicle
    } 
    status
    timestamp
  }
`;
exports.contractFragments = `
  ${exports.contractFragment}
  ${document_1.documentFragment}
`;
//# sourceMappingURL=contract.js.map